module.exports = __webpack_public_path__ + "img/body-3-lg.76b8af4c.png";